import { render, staticRenderFns } from "./talentDialog.vue?vue&type=template&id=a2a6c676&scoped=true"
import script from "./talentDialog.vue?vue&type=script&lang=js"
export * from "./talentDialog.vue?vue&type=script&lang=js"
import style0 from "./talentDialog.vue?vue&type=style&index=0&id=a2a6c676&prod&lang=less&scoped=true"
import style1 from "./talentDialog.vue?vue&type=style&index=1&id=a2a6c676&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a6c676",
  null
  
)

export default component.exports